var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0383 6.97582C24.7513 5.9019 23.9056 5.05624 22.8317 4.76921C20.885 4.24756 13.0799 4.24756 13.0799 4.24756C13.0799 4.24756 5.27474 4.24756 3.32803 4.76921C2.25432 5.05624 1.40845 5.9019 1.12143 6.97582C0.599976 8.92232 0.599976 12.9836 0.599976 12.9836C0.599976 12.9836 0.599976 17.0449 1.12143 18.9912C1.40845 20.0651 2.25432 20.911 3.32803 21.198C5.27474 21.7194 13.0799 21.7194 13.0799 21.7194C13.0799 21.7194 20.885 21.7194 22.8317 21.198C23.9056 20.911 24.7513 20.0651 25.0383 18.9912C25.5599 17.0449 25.5599 12.9836 25.5599 12.9836C25.5599 12.9836 25.5599 8.92232 25.0383 6.97582Z",
    fill: "#ED1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5837 16.7276L17.0684 12.9835L10.5837 9.23947V16.7276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.599976 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c88910ad008366d3ebfe738699579827.svg";
export { ForwardRef as ReactComponent };